module.exports = __webpack_public_path__ + "static/media/21.71e68555.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/21.jpg
// module id = 196
// module chunks = 0